import { Data } from '@angular/router';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { ITypeaheadIcon } from '../interfaces/typeahead-icon.interface';

@Component({
    selector: 'odd-typeahead',
    templateUrl: './typeahead.component.html',
    styleUrls: [ './typeahead.component.scss' ],
})

export class TypeaheadComponent {
    public text: string;
    public isFocus: boolean;
    public inDropdown: boolean;

    @Input() public readonly name: string;
    @Input() public readonly model: Data[];
    @Input() public readonly length: number;
    @Input() public readonly attribute: string;
    @Input() public readonly placeholder: string;
    @Input() public readonly iconLeft: ITypeaheadIcon;

    @Output('onClick') public readonly fireClick: EventEmitter<Data> = new EventEmitter<Data>();
    @Output('onSearch') public readonly fireSearch: EventEmitter<string> = new EventEmitter<string>();

    public onChange() {
        if (this.text.length >= this.length) {
            this.fireSearch.emit(this.text);
        }
    }

    public onClick(element) {
        this.text = '';
        this.inDropdown = false;
        this.fireClick.emit(element);
    }

    @HostListener('focusin')
    @HostListener('focusout')
    public setFocus(): void {
        this.isFocus = !this.isFocus;
    }
}
